import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Styles
import styles from './button.module.scss';

const cx = classnames.bind(styles);

const Button = ({
  type = 'primary',
  loading = false,
  disabled = false,
  style = {},
  onClick = () => {},
  children,
  className = '',
  ...rest
}) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className={cx(
      styles.btn,
      styles[type],
      {
        [styles.disabledOrLoading]: disabled || loading,
      },
      className,
    )}
    style={{ ...style }}
    {...rest}
  >
    {children}
  </button>
);

Button.propTypes = {
  type: PropTypes.oneOf([
    'transparent',
    'default',
    'primary',
    'secondary',
    'success',
    'danger',
    'ghost',
  ]),
  fullWidth: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  icon: PropTypes.element,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.shape(),
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Button;
